import { useDispatch, useSelector } from "react-redux";
import { globalActions } from "../slice";
import {
  selectStayDate,
} from "../selectors";
import styles from "../../../dashboard/dashboard.module.scss";
import { Grid } from "@mui/material";
import DateRangePicker  from "../../components/DateRangePicker";
import { formatDateLabel } from "../../../dashboard/functions";
import { format } from "date-fns";
//
const formatDate = (date) => format(new Date(date), 'yyyy-MM-dd');

/**
 * StayDatePicker Component
 * @returns {JSX.Element} A component to select and display stay date ranges
 */

const StayDatePicker = () => {
  const dispatch = useDispatch();
  const stayDate = useSelector(selectStayDate);
  return (
    <Grid container justifyContent="center">
        <DateRangePicker
        label={"Stay Date Range"}
        handleChange={(item) =>
                  dispatch(
                    globalActions.setStayDate({
                      startDate: formatDate(new Date(item.selection.startDate)),
                      endDate: formatDate(new Date(item.selection.endDate)),
                      key: "selection",
                    })
                  )
                }
        ranges={[stayDate]}
        dateValue={formatDateLabel(stayDate)}
        cssClassName={styles.bookingCalendarElement}
        />
    </Grid>
  );
};
//
export default StayDatePicker;
